// Optional: set REACT_APP_FORMSPREE_ENDPOINT in frontend/.env to email you form submissions.
// Example: REACT_APP_FORMSPREE_ENDPOINT=https://formspree.io/f/xxxxxxxx
// If not set, the contact form will only send via WhatsApp.

const FORMSPREE_ENDPOINT = process.env.REACT_APP_FORMSPREE_ENDPOINT || "";

export const hasFormspree = Boolean(FORMSPREE_ENDPOINT);

export async function submitFormspree(payload) {
    if (!FORMSPREE_ENDPOINT) {
        throw new Error("Formspree endpoint not configured");
    }
    const res = await fetch(FORMSPREE_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
    });
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data?.error || "Formspree submission failed");
    }
    return res.json();
}
